var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExperiment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.25,
    stroke: "currentColor",
    clipPath: "url(#icon-experiment_svg__A)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.687,
    cy: 24,
    rx: 13.204,
    ry: 21.002,
    transform: "rotate(315 24.687 24)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.687,
    cy: 24,
    rx: 13.204,
    ry: 21.002,
    transform: "rotate(45 24.687 24)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-experiment_svg__A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h48v48H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OSIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ5IDQ4IiBmaWxsPSJub25lIiB4bWxuczp2PSJodHRwczovL3ZlY3RhLmlvL25hbm8iPjxnIGNsaXAtcGF0aD0idXJsKCNBKSI+PGcgc3Ryb2tlPSJjdXJyZW50Q29sb3IiPjxnIHN0cm9rZS13aWR0aD0iMS4yNSI+PGVsbGlwc2UgY3g9IjI0LjY4NyIgY3k9IjI0IiByeD0iMTMuMjA0IiByeT0iMjEuMDAyIiB0cmFuc2Zvcm09InJvdGF0ZSgzMTUgMjQuNjg3IDI0KSIvPjxlbGxpcHNlIGN4PSIyNC42ODciIGN5PSIyNCIgcng9IjEzLjIwNCIgcnk9IjIxLjAwMiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMjQuNjg3IDI0KSIvPjwvZz48L2c+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iQSI+PHBhdGggZmlsbD0iI2ZmZiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjUpIiBkPSJNMCAwaDQ4djQ4SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";
export { SvgIconExperiment as ReactComponent };